import authHeader from './auth-header';
import Api from './api';

const API_URL = process.env.REACT_APP_AQUA_API_ENDPOINT

class PanelConfigService {
  async getPanelConfig() {
    return await Api().get(`${API_URL}/panel/getPanelConfig`, { headers:  authHeader() as any });      
  }
}

export default new PanelConfigService();